<template>
    <footer id="footer-section">
        <b-container class="d-flex flex-column justify-content-center align-items-center pt-5 pb-2">

            <b-row container>
                <b-col class="py-5">
                    <article class="midiasBox">

                        <div class="d-flex justify-content-center align-items-center logoBox">
                            <img src="@/assets/page/footer/logoFooter.webp" alt="">

                            <div> 
                                <p>Conecte-se e impulsione seu</p>
                                <p>negócio com inovação e eficiência</p>
                                <p>no transporte de commodities.</p>
                            </div>
                        </div>

                        <div class="d-flex justify-content-center align-items-center w-100" style="gap: 2rem; flex-wrap: wrap;">
                            <b-button
                                v-for="(midia, index) in midias"
                                :key="index"
                                :href="midia.url"
                                target="_blank"
                                class="btn-midia"
                            >
                                <b-icon :icon="midia.icon"></b-icon>
                            </b-button>
                        </div>
                    </article>
                </b-col>
            </b-row>

            <div class="d-flex justify-content-center flex-column align-items-center pt-3 w-100" style="border-top: 2px solid var(--anis); text-align: center;">
                <span style="font-size: 14px;">CNPJ: 39.919.489/0001-35 - ©2025 All Rights Reserved</span>
                <span style="font-size: 14px;">Desenvolvido por <a class="linkDev" href="https://marcosmontedev.vercel.app/" target="_blank">Marcos Monte</a></span>
            </div>

        </b-container>
    </footer>
</template>

<script>

    export default {

        name: 'Footer',

        data() {
            return {
                midias: [
                    { icon: 'whatsapp', url: 'https://wa.me/556696924173/?text=Olá,%20gostaria%20de%20mais%20informações!' },
                    { icon: 'facebook', url: 'https://facebook.com/share/1YeM4LZ1jb/?mibextid=wwXIfr' },
                    { icon: 'instagram', url: 'https://instagram.com/frazattologistica?igsh=emtlcGtrcmxzaHls' },
                    { icon: 'linkedin', url: 'https://www.linkedin.com/company/frazatto-log%C3%ADstica-ltda/' },
                ]
            };
        },
    }

</script>

<style scoped lang="scss">

    #footer-section {
        background-color: var(--primaryColorDark);
        width: 100vw;
        color: var(--anis);
        padding: 0 10px
    }

    .linkDev {
        color: var(--anis);

        &:hover {
            color: var(--white);
        }
    }

    .midiasBox {
        width: 100&;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 3rem;
        
        .logoBox {
            gap: 5rem;

            p {
                text-align: left;
                padding: none;
                margin: 0px !important;
                font-size: 20px;
            }
        }

        img {
            width: 50%;
            padding-right: 4rem;
            border-right: 1px solid var(--anis);
        }

    }

@media screen and (max-width: 992px){
    .logoBox {
        flex-direction: column !important;
        gap: 2.5rem !important;

        img {
            border: none;
            padding-right: 0;
            min-width: 250px;
        }

        p {
            text-align: center !important;
            padding: none;
            margin: 0px !important;
            font-size: 20px;
        }
    }
}

</style>